import { ReactNode } from 'react';
import { MapPin, List } from 'lucide-react';
import { Location } from '../../lib/supabase';
import defaultExpenseTypesData from '../../data/defaultExpenseTypes.json';

interface LocationItemProps {
    location: Location;
    slug?: string;
    isAdminView?: boolean;
    compact?: boolean;
    selected?: boolean;
    className?: string;
    onClick?: () => void;
    suffix?: ReactNode;
}

export function LocationItem({ location, compact, selected, className, onClick, suffix }: LocationItemProps) {
    const lastTypeKey = (location as any).last_expense_type;
    const typeInfo = lastTypeKey ? (defaultExpenseTypesData as any)[lastTypeKey] : null;
    const iconColor = typeInfo?.color || '#10b981'; // Default emerald-500

    return (
        <div
            onClick={onClick}
            className={[
                'w-full text-left p-4 transition-colors group flex gap-3',
                compact
                    ? (onClick ? 'hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer' : '')
                    : 'rounded-2xl border border-gray-100 dark:border-white/10 hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer text-left w-full',
                !compact && selected ? 'border-blue-500 ring-2 ring-blue-500/10' : '',
                className || ''
            ].filter(Boolean).join(' ')}
        >
            <div
                className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center pt-0.5 overflow-hidden"
                style={{ backgroundColor: `${iconColor}15` }}
            >
                {location.image_url_thumb || location.image_url ? (
                    <img
                        src={location.image_url_thumb || location.image_url || ''}
                        alt={location.name}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <MapPin size={20} style={{ color: iconColor }} />
                )}
            </div>
            <div className="min-w-0 flex-1 py-0.5">
                <div className="flex items-center justify-between mb-1">
                    <h3 className="font-bold text-gray-900 dark:text-white truncate pr-2 leading-tight">
                        {location.name}
                    </h3>
                </div>
                {location.address && (
                    <p className="text-sm font-medium text-gray-500 line-clamp-2 leading-relaxed">
                        {location.address}
                    </p>
                )}
            </div>

            {((location as any).entryCount > 0 || (location as any).entry_count > 0) && (
                <div className="flex flex-col items-end justify-center self-stretch pr-1">
                    <div className="flex items-center gap-1 text-emerald-500 dark:text-emerald-400">
                        <List size={14} />
                        <span className="text-xs font-medium">{(location as any).entryCount || (location as any).entry_count}</span>
                    </div>
                </div>
            )}

            {suffix}
        </div>
    );
}
